import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const V=t("great_britain",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="white" />
            <path
                d="M13.5 4.5H10.5V10.9999H0V13.9999H10.5V20.4998H13.5V13.9999H24V10.9999H13.5V4.5Z"
                fill="#D80027" />
            <path
                d="M18.4589 15.2822L24.0002 18.3608V15.2822H18.4589ZM14.6089 15.2822L24.0002 20.4995V19.0242L17.2646 15.2822H14.6089ZM21.4987 20.4995L14.6089 16.6716V20.4995H21.4987Z"
                fill="#0052B4" />
            <path
                d="M14.6089 15.2822L24.0002 20.4995V19.0242L17.2646 15.2822H14.6089Z"
                fill="white" />
            <path
                d="M14.6089 15.2822L24.0002 20.4995V19.0242L17.2646 15.2822H14.6089Z"
                fill="#D80027" />
            <path
                d="M4.23473 15.2822L0 17.6349V15.2822H4.23473ZM9.3913 15.9457V20.4996H1.19489L9.3913 15.9457Z"
                fill="#0052B4" />
            <path
                d="M6.7356 15.2822L0 19.0242V20.4995L9.3913 15.2822H6.7356Z"
                fill="#D80027" />
            <path
                d="M5.54132 9.71732L0 6.63879V9.71732H5.54132ZM9.3913 9.71732L0 4.5V5.97533L6.7356 9.71732H9.3913ZM2.50153 4.5L9.3913 8.32796V4.5H2.50153Z"
                fill="#0052B4" />
            <path
                d="M9.3913 9.71732L0 4.5V5.97533L6.7356 9.71732H9.3913Z"
                fill="white" />
            <path
                d="M9.3913 9.71732L0 4.5V5.97533L6.7356 9.71732H9.3913Z"
                fill="#D80027" />
            <path
                d="M19.7655 9.71737L24.0002 7.36473V9.71737H19.7655ZM14.6089 9.0539V4.5H22.8053L14.6089 9.0539Z"
                fill="#0052B4" />
            <path
                d="M17.2646 9.71732L24.0002 5.97533V4.5L14.6089 9.71732H17.2646Z"
                fill="#D80027" />
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40031"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40031)">
            <g clip-path="url(#clip0_4915_40031)">
                <path
                    d="M-5.96484 0.492188H30.0352V24.4924H-5.96484V0.492188Z"
                    fill="white" />
                <path
                    d="M14.2852 0.492188H9.78516V10.2421H-5.96484V14.7421H9.78516V24.4921H14.2852V14.7421H30.0352V10.2421H14.2852V0.492188Z"
                    fill="#D80027" />
                <path
                    d="M21.7232 16.666L30.0352 21.2839V16.666H21.7232ZM15.9482 16.666L30.0352 24.4921V22.2791L19.9318 16.666H15.9482ZM26.2829 24.4921L15.9482 18.7501V24.4921H26.2829Z"
                    fill="#0052B4" />
                <path
                    d="M15.9482 16.666L30.0352 24.4921V22.2791L19.9318 16.666H15.9482Z"
                    fill="white" />
                <path
                    d="M15.9482 16.666L30.0352 24.4921V22.2791L19.9318 16.666H15.9482Z"
                    fill="#D80027" />
                <path
                    d="M0.387258 16.666L-5.96484 20.195V16.666H0.387258ZM8.12213 17.6612V24.4922H-4.17251L8.12213 17.6612Z"
                    fill="#0052B4" />
                <path
                    d="M4.13857 16.666L-5.96484 22.2791V24.4921L8.12213 16.666H4.13857Z"
                    fill="#D80027" />
                <path
                    d="M2.34715 8.31825L-5.96484 3.70041V8.31825H2.34715ZM8.12213 8.31825L-5.96484 0.492188V2.7052L4.13857 8.31825H8.12213ZM-2.21255 0.492188L8.12213 6.23419V0.492188H-2.21255Z"
                    fill="#0052B4" />
                <path
                    d="M8.12213 8.31825L-5.96484 0.492188V2.7052L4.13857 8.31825H8.12213Z"
                    fill="white" />
                <path
                    d="M8.12213 8.31825L-5.96484 0.492188V2.7052L4.13857 8.31825H8.12213Z"
                    fill="#D80027" />
                <path
                    d="M23.6831 8.31832L30.0352 4.78934V8.31832H23.6831ZM15.9482 7.32312V0.492188H28.2429L15.9482 7.32312Z"
                    fill="#0052B4" />
                <path
                    d="M19.9318 8.31825L30.0352 2.7052V0.492188L15.9482 8.31825H19.9318Z"
                    fill="#D80027" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40031">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.492188)" />
            </clipPath>
        </defs>
    </svg>
`,p=t("great_britain_rounded",l),d=t("GBP",l);export{d as GBP,V as GreatBritain,p as GreatBritainRounded,l as GreatBritainRoundedSvg};
